import { React, useState } from "react";
import { useNavigate } from "react-router-dom";
import { ChevronLeft } from 'lucide-react';
import * as Yup from 'yup';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

function AccountDeposit() {
  const navigate = useNavigate();

  const [activeTab, setActiveTab] = useState('INR'); // Default active tab is "INR"
  const [amount, setAmount] = useState(''); // State for amount field

  const handleGoBack = () => {
    navigate(-1);
  };

  // Yup validation schema for amount field
  const validationSchema = Yup.object({
    amount: Yup.number()
      .required("Amount is required") // Amount field is required
      .positive("Amount must be a positive number") // Ensure amount is positive
      .min(1, "Amount must be greater than 0"), // Amount should be greater than 0
  });

  // Handle form submission for Option 1 and Option 2 buttons
  const handleSubmit = async (e, option) => {
    e.preventDefault();

    const values = { amount };

    try {
      // Validate input using Yup
      await validationSchema.validate(values, { abortEarly: false });

      // If valid, display success message
      toast.success(`${option} submitted successfully!`);
    } catch (err) {
      // If validation fails, show error messages via Toastify
      err.inner.forEach((error) => {
        toast.error(error.message);
      });
    }
  };

  return (
    <div className="flex items-center justify-center flex-col bg-black min-h-screen p-0">
      <div className="h-screen overflow-y-scroll p-4 pb-20 flex-grow max-w-sm min-w-[375px] w-full bg-white 
            [&::-webkit-scrollbar]:w-1 
            [&::-webkit-scrollbar-track]:bg-transparent 
            [&::-webkit-scrollbar-thumb]:bg-transparent 
            scrollbar-thin scrollbar-track-transparent scrollbar-thumb-transparent">
        
        <div className="flex items-center justify-between mb-[30px]">
          <div className="flex items-center gap-1">
            <ChevronLeft size={16} onClick={handleGoBack} />
            <span className="font-lato font-semibold text-sm">Deposit</span>
          </div>
          <div className="flex justify-end bg-white border-b-0 rounded-[10px] max-w-[127px] w-full">
            <div role="tablist" className="flex bg-[#536895] bg-opacity-25 rounded-[10px]">
              <a href="#" role="tab" onClick={() => setActiveTab('INR')}
                className={`${
                  activeTab === 'INR' ? 'bg-[#536895] text-white' : 'bg-transparent text-black'
                } font-lato text-sm leading-[18px] rounded-[10px] py-[10px] px-[14px] text-center w-[63px]`}
              >
                INR
              </a>
              <a href="#" role="tab" onClick={() => setActiveTab('Forex')}
                className={`${
                  activeTab === 'Forex' ? 'bg-[#536895] text-white' : 'bg-transparent text-black'
                } font-lato text-sm leading-[18px] rounded-[10px] py-[10px] px-[14px] text-center w-[63px]`}
              >
                Forex
              </a>
            </div>
          </div>
        </div>

        <div className="w-full items-center justify-between mb-[30px]">
          <form onSubmit={(e) => e.preventDefault()}>

            {/* Amount input */}
            <div className="mb-4">
              <label className="w-full text-[14px] leading-[21px] text-gray-700 font-lato mb-2 block" htmlFor="amount">
                Amount
              </label>
              <input
                placeholder="Amount"
                type="number"
                id="amount"
                name="amount"
                value={amount}
                onChange={(e) => setAmount(e.target.value)} // Update amount state
                className="w-full bg-gray-300 rounded-[5px] px-4 py-2"
              />
            </div>

            {/* Option 1 Button */}
            <div className="mt-6">
              <button
                type="button"
                onClick={(e) => handleSubmit(e, "Option 1")} // Pass Option 1 to handleSubmit
                className="w-full bg-[#536895] border border-[#536895] rounded-lg text-white text-[16px] font-semibold py-[14px] px-[55px]"
              >
                Option 1
              </button>
            </div>

            {/* Option 2 Button */}
            <div className="mt-3">
              <button
                type="button"
                onClick={(e) => handleSubmit(e, "Option 2")} // Pass Option 2 to handleSubmit
                className="w-full bg-[#536895] border border-[#536895] rounded-lg text-white text-[16px] font-semibold py-[14px] px-[55px]"
              >
                Option 2
              </button>
            </div>

          </form>
        </div>
      </div>

      {/* Toast Container for Toastify notifications */}
      <ToastContainer />
    </div>
  );
}

export default AccountDeposit;